import 'angular-route';
import angular from 'angular';
import router from './module.encoderprofiles.routes';
import commonServicesModule from '../../services';

export const encoderprofilesModule = {
	name: 'encoderprofiles',
	controllers: {
		default: 'encoderProfilesCtrl',
	},
	routes: {
		list: '/encoderprofiles',
		details: '/encoderprofiles/:id',
	},
};

export default angular
	.module(encoderprofilesModule.name, ['ngRoute', commonServicesModule])
	.config(router)
	.controller(encoderprofilesModule.controllers.default, require('./encoderProfilesCtrl')).name;
